
export default [

  {
    path: '/policyDetail',
    name: 'policyDetail',
    component: () => import('@/page/policy/policyDetail')
  },
]